import React, { useState ,useEffect} from 'react';
import { Link, BrowserRouter as Router, Route, Switch, } from "react-router-dom";
import './collections.css'
import singam from "./Im/singam.png"
import boss from "./Im/boss.png"
import sivaji from "./Im/sivaji.png";
import vijay from "./Im/vijay.png";
import telugu_h from "./Im/telugu_h.png"
import Fotter from '../../Home/Home_modules/Footerr/footer';
import Top_selling_cards from '../../Home/Home_modules/Top_selling_cards';
import fire from './Im/hcfire.png'
import explore from './Im/hcexplore.png';
import DatePicker from 'react-date-picker';
import f1 from './Im/1.png';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import si from './Im/si.png';
import ka from './Im/Ka.png';
import Mer from './Im/Mer.png';
import Vik from './Im/Vik.png';
import './res.css'
import vi from './Im/vivek.jpg'
import pfp from './Im/pfp.jpg'
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css'


function Collections() {
    const [value, onChange] = useState(new Date());
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 1,
          partialVisibilityGutter: 140
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 1,
          partialVisibilityGutter: 140
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 1,
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
        }
      };

      useEffect(() => { finddevice() }, []);
    
      function finddevice(){
         const details = navigator.userAgent;
        let regexp = /android|iphone|kindle|ipad/i;
         let isMobileDevice = regexp.test(details);
         if (isMobileDevice) {
            document.getElementById("skeleton_loader").style.display = "none";
            document.getElementById("data_load").style.display = "";
         } else {
        //wait the division to load until Gets the data....
        setTimeout(function(){
            document.getElementById("skeleton_loader").style.display = "none";
            document.getElementById("data_load").style.display = "";
          }, 3000); 
         }
    }
   
    return (
        <div>
            <div className="main">
                <div className="collections-page">
         {/*   <div class="top-banner">
                <h2>Dynamic Content Video Banner</h2>
            </div>

            <div className="featured">
                <div className="featured-main">
                    <img src={singam} alt="Logo" />

                    <h1 className="singam-text">Singam</h1>
                    <button className="load-bt"></button>
                    <button className="load-bt"></button>
                    <button className="load-bt"></button>
                    <button className="load-bt"></button>
                    <button className="load-bt"></button>
                    <button className="load-bt"></button>
                </div>
                <div className="featured-grid">
                    <div className="featured-grid-r1" >
                        <img className="movie-block" src={telugu_h} alt="Logo" />
                        <h3 className="movie-text">Fear  him</h3>
                        <div className="time"><h3 className="tstamp">20.9.9</h3></div>
                    </div>
                    <div className="featured-grid-r1">
                        <img className="movie-block" src={boss} alt="Logo" />
                        <h3 className="movie-text">Motta boss still</h3>
                        <div className="time"><h3 className="tstamp">20.9.9</h3></div>
                    </div>
                    <div className="featured-grid-r2">
                        <img className="movie-block" src={sivaji} alt="Logo" />
                        <h3 className="movie-text">Rajini swag</h3>
                        <div className="time"><h3 className="tstamp">20.9.9</h3></div>
                    </div>
                    <div className="featured-grid-r2">
                        <img className="movie-block" src={vijay} alt="Logo" />
                        <h3 className="movie-text">Romance 101</h3>
                        <div className="time"><h3 className="tstamp">20.9.9</h3></div>
                    </div>
                </div>
            </div>
            */}
            <div id="skeleton_loader" style={{display: ''}}>
                <Carousel 
                 responsive={responsive}
                 partialVisible={true}
                 showDots={true}
                 autoPlay={true}
                 autoPlaySpeed={5000}
                 infinite={true}
                 containerClass='movies-slider'
                 removeArrowOnDeviceType={["desktop","tablet", "mobile"]}
               
                 >
            <div className="featured-slider">
                <div className="featured-slider-main">
                <div className="featured-content">
                    <h1><Skeleton baseColor="#080824" highlightColor="#b1b2bc"/></h1>
                    <p><Skeleton baseColor="#080824" count={5} highlightColor="#b1b2bc"/></p>
                   <Link to ="/sivaji"> <Skeleton baseColor="#080824" width={208} height={50} highlightColor="#b1b2bc"/></Link>
                </div>
                <div className="featured-image">
                <Skeleton baseColor="#080824" highlightColor="#b1b2bc" width={350} height={400}/>
                </div>
                </div>
            </div>
            <div className="featured-slider">
                <div className="featured-slider-main">
                <div className="featured-content">
                    <h1><Skeleton baseColor="#080824" highlightColor="#b1b2bc"/></h1>
                    <p><Skeleton baseColor="#080824" count={5} highlightColor="#b1b2bc"/></p>
                   <Link to ="/sivaji"> <Skeleton baseColor="#080824" width={208} height={50} highlightColor="#b1b2bc"/></Link>
                </div>
                <div className="featured-image">
                <Skeleton baseColor="#080824" highlightColor="#b1b2bc" width={350} height={400}/>
                </div>
                </div>
            </div>
            <div className="featured-slider">
                <div className="featured-slider-main">
                <div className="featured-content">
                    <h1><Skeleton baseColor="#080824" highlightColor="#b1b2bc"/></h1>
                    <p><Skeleton baseColor="#080824" count={5} highlightColor="#b1b2bc"/></p>
                   <Link to ="/sivaji"> <Skeleton baseColor="#080824" width={208} height={50} highlightColor="#b1b2bc"/></Link>
                </div>
                <div className="featured-image">
                <Skeleton baseColor="#080824" highlightColor="#b1b2bc" width={350} height={400}/>
                </div>
                </div>
            </div>
            <div className="featured-slider">
                <div className="featured-slider-main">
                <div className="featured-content">
                    <h1><Skeleton baseColor="#080824" highlightColor="#b1b2bc"/></h1>
                    <p><Skeleton baseColor="#080824" count={5} highlightColor="#b1b2bc"/></p>
                   <Link to ="/sivaji"> <Skeleton baseColor="#080824" width={208} height={50} highlightColor="#b1b2bc"/></Link>
                </div>
                <div className="featured-image">
                <Skeleton baseColor="#080824" highlightColor="#b1b2bc" width={350} height={400}/>
                </div>
                </div>
            </div>
            </Carousel></div>


            <div id="data_load" style={{display: 'none'}}>
            <Carousel 
                 responsive={responsive}
                 partialVisible={true}
                 showDots={true}
                 autoPlay={true}
                 autoPlaySpeed={5000}
                 infinite={true}
                 containerClass='movies-slider'
                 removeArrowOnDeviceType={["desktop","tablet", "mobile"]}
                 style={{display:'none'}}
                 >
            <div className="featured-slider">
                <div className="featured-slider-main">
                <div className="featured-content">
                    <h1>Sivaji</h1>
                    <p>Sivaji: The Boss is a 2007 Indian cult-classic Tamil-language action film produced by AVM Productions. The film stars Rajinikanth and A R Rahman composed the soundtrack and background music. The movie raked over 150 crores in the box office in 2007!</p>
                   <Link to ="/sivaji"> <button className="featured-slide-btn">CHECK IT OUT</button></Link>
                </div>
                <div className="featured-image">
                    <img src={si} />
                </div>
                </div>
            </div>
            <div className="featured-slider">
                <div className="featured-slider-main">
                <div className="featured-content">
                    <h1>Chandramukhi</h1>
                    <p>Chandramukhi is a 2005 Indian Tamil-language comedy horror produced by Sivaji Productions. The film stars Rajinikanth, Prabhu, Jyothika, Vadivelu, and Nayanthara. The cult classic collected over 80 crores in the box office back in 2005!</p>
                    <Link to ="/Chandramukhi"> <button className="featured-slide-btn">CHECK IT OUT</button></Link>
                </div>
                <div className="featured-image">
                    <img src={f1} />
                </div>
                </div>
            </div>
            <div className="featured-slider">
                <div className="featured-slider-main">
                <div className="featured-content">
                    <h1>Kabali</h1>
                    <p>Kabali is a 2016 Indian Tamil-language action drama film produced by Kalaipuli S. Thanu. The film stars Rajinikanth and contains iconic signature dialogues and scenes from Rajinikanth. The movie collected over 300 crores at the box office.</p>
                    <Link to ="/Kabali"> <button className="featured-slide-btn">CHECK IT OUT</button></Link>
                </div>
                <div className="featured-image">
                    <img src={ka} />
                </div>
                </div>
            </div>
            <div className="featured-slider">
                <div className="featured-slider-main">
                <div className="featured-content">
                    <h1>Pasumai Nayagan Vivek</h1>
                    <p>This is a unique Physical Digital NFT asset. Collectors will receive a hard copy of their NFT as a poster delivered to their doorstep - anywhere in the world, and along with the NFT holder will receive a Seed bag or a plant sapling.</p>
                    <Link to ="/PasumaiNayaganVivek"> <button className="featured-slide-btn">CHECK IT OUT</button></Link>
                </div>
                <div className="featured-image">
                    <img src={pfp} />
                </div>
                </div>
            </div>
            </Carousel>
            </div>

            <div className="hot-collections">
                <h2>HOT COLLECTIONS<img className="hundred" src={fire} /></h2>
                <div className="hc-card-grid">
                   <Link to="/kabali"><div className="hc-card">
                        <div className="hc1">
                        </div>
                        <div className="hc-content">
                            <img src={ka} />
                            <h4>Kabali</h4>
                            
                        </div>
                    </div></Link> 
                    <Link to="/sivaji"><div className="hc-card">
                        <div className="hc1">
                        </div>
                        <div className="hc-content">
                            <img src={si} />
                            <h4>Sivaji</h4>
                            
                        </div>
                    </div></Link>
                    <Link to="/chandramukhi"><div className="hc-card">
                        <div className="hc1">
                        </div>
                        <div className="hc-content">
                            <img src={f1} />
                            <h4>Chandramukhi</h4>
                            
                        </div>
                    </div></Link>
                    <Link to='/PasumaiNayaganVivek'>
                    <div className="hc-card">
                        <div className="hc1">
                        </div>
                        <div className="hc-content">
                            <img src={vi} />
                            <h4 style={{fontSize:'14px'}}>Pasumai Nayagan Vivek</h4>

                        </div>
                    </div>
                    </Link>
                    <div className="hc-card">
                        <div className="hc1">
                        </div>
                        <div className="hc-content">
                            <img src={Mer} />
                            <h4>Coming soon</h4>
                            
                        </div>
                    </div>
                </div>
            </div>



            {/* explore section */}

            <div className="explore">
              {/* <div className="explore-head">
                    <h1 className="explore-top">EXPLORE<img className="hundred" src={explore} /></h1>
                    <div className="explore-top">
                    <DatePicker className="datepicker" name="date" label="Date"
        onChange={onChange}
        value={value}
      />
                    </div>
                    <div className="explore-top">
                        <select name="actors">
                            <option selected>Actors</option>
                            <option value="">Shivaji</option>
                            <option value="">Vijay</option>
                            <option value="">Surya</option>
                            <option value="">4</option>
                        </select>
                    </div>
                    <div className="explore-top">
                        <select name="price-range">
                            <option selected>Price range</option>
                            <option value="">$1499</option>
                            <option value="">$499</option>
                            <option value="">$399</option>
                            <option value="">$199</option>
                        </select>
                    </div>
        </div> */}
                <Top_selling_cards />
                <br></br>
            </div>

            </div>
            
            </div> <br></br> <br></br> <br></br>
            <Fotter />
            </div>
    )

            
}

export default Collections